import { h, Component } from "preact";
import "./countdownApplet.scss";

interface CountdownAppletProps {
}

interface CountdownAppletState {
    title: string;
}

export class CountdownApplet extends Component<CountdownAppletProps, CountdownAppletState> {
    constructor(props: CountdownAppletProps) {
        super(props);

        this.state = {
            title: "New timer"
        };
    }

    render(props: CountdownAppletProps, state: CountdownAppletState) {
        return (
            <div className="applet__countdown inactive">
                <div>Countdown applet goes here!</div>
                <div>
                    <input type="text" value={state.title} />
                </div>
                <div className="applet__countdown_duration">
                    <input type="tel" pattern="\d*" maxLength={2} className="" placeholder="HH" />
                    <span className="separator">:</span>
                    <input type="tel" pattern="\d*" maxLength={2} className="" placeholder="MM" />
                    <span className="separator">:</span>
                    <input type="tel" pattern="\d*" maxLength={2} className="" placeholder="SS" />
                </div>
            </div>
        );
    }
}


